<ng-container>
  <div id="mobilityManagerPaymentAccountForm-container" class="container">
    <h1>
      {{ isEditMode ? 'Edit Payment Method' : 'Add Payment Method' }}
    </h1>

    <form [formGroup]="creditCardForm" autocomplete="off">
      <div class="column">
        <ng-container *ngIf="!isEditMode" [ngTemplateOutlet]="nicknameField"></ng-container>

        <ng-container *ngIf="isEditMode; else mmCardNumberInput">
          <div class="hidden-card-number">
            <p [attr.aria-label]="'Name ' + paymentAccount.billingFirstName + ' ' + paymentAccount.billingLastName + ', non-editable'">
              <span aria-hidden="true">{{ paymentAccount.billingFirstName }} {{ paymentAccount.billingLastName }}</span>
            </p>
            <p id="mobilityManagerPaymentAccountForm-text-maskedCardNumber"
               [attr.aria-label]="'Card number ending in ' + paymentAccount.cardNumber + ', non-editable'">
              <span aria-hidden="true"> **** **** **** {{ paymentAccount.cardNumber }}</span>
            </p>
          </div>
        </ng-container>
        <ng-container *ngIf="isEditMode" [ngTemplateOutlet]="nicknameField"></ng-container>

        <mat-form-field *ngIf="!isEditMode" appearance="outline">
          <mat-label>First Name</mat-label>
          <input
            id="mobilityManagerPaymentAccountForm-input-firstName"
            matInput
            type="text"
            name="billingFirstName"
            formControlName="billingFirstName"
            autocomplete="off"
            data-private="lipsum"
          />
          <mat-error *ngIf="creditCardForm.controls.billingFirstName.hasError('required')">
            First Name is required
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="!isEditMode" appearance="outline">
          <mat-label>Last Name</mat-label>
          <input
            id="mobilityManagerPaymentAccountForm-input-lastName"
            matInput
            type="text"
            name="billingLastName"
            formControlName="billingLastName"
            autocomplete="off"
            data-private="lipsum"
          />
          <mat-error *ngIf="creditCardForm.controls.billingLastName.hasError('required')">
            Last Name is required
          </mat-error>
        </mat-form-field>
        <ng-container *ngIf="!isEditMode" [ngTemplateOutlet]="expAndCvv"></ng-container>
        <ng-container *ngIf="isCreditCardValidationEnabled">
          <h3>Billing Address</h3>
          <mat-form-field appearance="outline">
            <mat-label>Billing Address Line 1</mat-label>
            <input
              id="mobilityManagerPaymentAccountForm-input-streetAddress"
              matInput
              type="text"
              formControlName="billingStreetAddress1"
              data-private="lipsum"
            />
            <mat-error *ngIf="creditCardForm.controls.billingStreetAddress1.hasError('required')">
              Billing Address is required
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Billing Address Line 2 (optional)</mat-label>
            <input
              id="mobilityManagerPaymentAccountForm-input-streetAddress2"
              matInput
              type="text"
              formControlName="billingStreetAddress2"
              data-private="lipsum"
            />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input
              id="mobilityManagerPaymentAccountForm-input-city"
              matInput
              type="text"
              formControlName="billingCity"
              data-private="lipsum"
            />
            <mat-error *ngIf="creditCardForm.controls.billingCity.hasError('required')">
              City is required
            </mat-error>
          </mat-form-field>
          <div class="row">
            <mat-form-field appearance="outline" class="flex-1">
              <mat-label>State</mat-label>
              <mat-select id="mobilityManagerPaymentAccountForm-select-state" formControlName="billingState" data-private="lipsum">
                <mat-option id="mobilityManagerPaymentAccountForm-option-{{ state.code }}" *ngFor="let state of states" [value]="state.code">
                  {{ state.code }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="creditCardForm.controls.billingState.hasError('required')">
                State is required
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="flex-1">
              <mat-label>Zip Code</mat-label>
              <input
                matInput
                type="number"
                id="mobilityManagerPaymentAccountForm-input-zipCode"
                formControlName="billingZipCode"
                data-private="lipsum"
              />
              <mat-error *ngIf="creditCardForm.controls.billingZipCode.hasError('required')">
                Zip Code is required
              </mat-error>
            </mat-form-field>
          </div>
          <ng-container *ngIf="isEditMode" [ngTemplateOutlet]="expAndCvv"></ng-container>
        </ng-container>
      </div>

      <ng-template #mmCardNumberInput>
        <mat-form-field appearance="outline" class="card-number">
          <mat-label>Card Number</mat-label>
          <input
            id="mobilityManagerPaymentAccountForm-input-cardNumber"
            matInput
            type="tel"
            ccNumber
            formControlName="cardNumber"
            autocomplete="off"
            data-private="lipsum"
          />
          <mat-error *ngIf="creditCardForm.controls.cardNumber.hasError('required')">
            Card Number is required
          </mat-error>
          <mat-error *ngIf="!creditCardForm.controls.cardNumber.hasError('required') && creditCardForm.controls.cardNumber.invalid">
            Card Number is invalid
          </mat-error>
        </mat-form-field>
      </ng-template>

      <ng-template #nicknameField>
        <mat-form-field appearance="outline" class="nickname">
          <mat-label>Card Nickname</mat-label>
          <input
            id="mobilityManagerPaymentAccountForm-input-accountNickName"
            matInput
            placeholder="Pick a name for this account"
            type="text"
            name="userDescription"
            formControlName="userDescription"
            autocomplete="off"
          />
          <mat-error *ngIf="creditCardForm.controls.userDescription.hasError('required')">
            Card Nickname is required
          </mat-error>
        </mat-form-field>
      </ng-template>

      <ng-template #expAndCvv>
        <div class="row">
          <mat-form-field appearance="outline" class="flex-1">
            <mat-label>Exp Date</mat-label>
            <input
              id="mobilityManagerPaymentAccountForm-input-expirationDate"
              matInput
              formControlName="cardExpiration"
              (click)="expPicker.open()"
              autocomplete="off"
              data-private="lipsum"
              style="cursor: pointer"
            />
            <input
              [matDatepicker]="expPicker"
              [value]="expPickerDate"
              style="display: none"
            />
            <mat-datepicker-toggle matSuffix [for]="expPicker">
              <mat-icon svgIcon="uz-calendar" class="calendar-icon"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker
              #expPicker
              startView="multi-year"
              (monthSelected)="onMonthSelected($event, expPicker)"
            ></mat-datepicker>
            <mat-error *ngIf="creditCardForm.controls.cardExpiration.hasError('required')">
              Exp Date is required
            </mat-error>
            <mat-error *ngIf="!creditCardForm.controls.cardExpiration.hasError('required') && creditCardForm.controls.cardExpiration.hasError('expDate')">
              Exp date is expired
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="cvv flex-1">
            <mat-label>Security Code</mat-label>
            <input
              id="mobilityManagerPaymentAccountForm-input-securityCode"
              matInput
              type="tel"
              ccCVC
              formControlName="cardVerificationValue"
              autocomplete="off"
              data-private="lipsum"
            />
            <mat-error *ngIf="creditCardForm.controls.cardVerificationValue.hasError('required')">
              Security Code is required
            </mat-error>
            <mat-error *ngIf="!creditCardForm.controls.cardVerificationValue.hasError('required') && creditCardForm.controls.cardVerificationValue.invalid">
              Please re-enter security code
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </form>

    <mat-card-actions align="end">
      <button id="mobilityManagerPaymentAccountForm-button-cancel" mat-button [disabled]="submittingPaymentAccount" (click)="handleCancel()">Cancel</button>
      <button
        *ngIf="!isExpired"
        id="mobilityManagerPaymentAccountForm-button-save"
        mat-raised-button
        color="primary"
        uzDebounceClick
        [disabled]="submittingPaymentAccount"
        [debounceTime]="500"
        (debounceClick)="submitPaymentAccount()"
      >
        <mat-progress-spinner *ngIf="submittingPaymentAccount; else saveLabel" [mode]="'indeterminate'" [diameter]="20" [strokeWidth]="2">
        </mat-progress-spinner>
        <ng-template #saveLabel>Save</ng-template>
      </button>
    </mat-card-actions>
  </div>
</ng-container>
